export const highlightInfoBlock = (infoBlock) => {
    if (!infoBlock)
        return;
    infoBlock.classList.add("qt_behind", "qt_highlighted");
    setTimeout(() => {
        infoBlock.classList.remove("qt_highlighted");
    }, 1000);
    setTimeout(() => {
        infoBlock.classList.remove("qt_behind");
    }, 1500);
};
